module.exports = __webpack_public_path__ + "img/unmute.cb67869.svg";